import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/css/comment.css'
import Cookies from 'js-cookie'

Vue.prototype.$axios = axios
Vue.use(Element, {
  size: Cookies.get('size') || 'small' // set element-ui default size
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js